import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api.js'

export interface Account {
  name: string
  gstin: string | null
  walletAlerts: { email: boolean; whatsapp: boolean }
  /** When every checkout was paused, or null while they are running. */
  checkoutsPausedAt: string | null
  /** False for staff and read-only members; the API refuses them regardless. */
  canEdit: boolean
}

/** `/v1/account`, plus the two merchant-level writes the Settings tabs make. */
export function useAccount() {
  const queryClient = useQueryClient()
  const onSuccess = (): void => void queryClient.invalidateQueries({ queryKey: ['account'] })

  return {
    account: useQuery({ queryKey: ['account'], queryFn: () => api<Account>('/v1/account') }),
    saveBusiness: useMutation({
      mutationFn: (body: { name: string; gstin: string | null }) => api('/v1/account/business', { method: 'PUT', body }),
      onSuccess,
    }),
    savePause: useMutation({
      mutationFn: (paused: boolean) => api('/v1/account/pause', { method: 'PUT', body: { paused } }),
      onSuccess,
    }),
    saveAlerts: useMutation({
      mutationFn: (body: Account['walletAlerts']) => api('/v1/account/notifications', { method: 'PUT', body }),
      onSuccess,
    }),
  }
}
